import { render, staticRenderFns } from "./SeccionI.vue?vue&type=template&id=59276ded&"
import script from "./SeccionI.vue?vue&type=script&lang=js&"
export * from "./SeccionI.vue?vue&type=script&lang=js&"
import style0 from "./SeccionI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports